// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! =======================================================
                      VERSION  11.0.2              
========================================================= */
/*! =========================================================
 * bootstrap-slider.js
 *
 * Maintainers:
 *		Kyle Kemp
 *			- Twitter: @seiyria
 *			- Github:  seiyria
 *		Rohit Kalkur
 *			- Twitter: @Rovolutionary
 *			- Github:  rovolution
 *
 * =========================================================
 *
 * bootstrap-slider is released under the MIT License
 * Copyright (c) 2019 Kyle Kemp, Rohit Kalkur, and contributors
 * 
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 * 
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 *
 * ========================================================= */
.slider {
  display: inline-block;
  vertical-align: middle;
  position: relative;
}

.slider.slider-horizontal {
  width: 210px;
  height: 20px;
}

.slider.slider-horizontal .slider-track {
  height: 10px;
  width: 100%;
  margin-top: -5px;
  top: 50%;
  left: 0;
}

.slider.slider-horizontal .slider-selection, .slider.slider-horizontal .slider-track-low, .slider.slider-horizontal .slider-track-high {
  height: 100%;
  top: 0;
  bottom: 0;
}

.slider.slider-horizontal .slider-tick,
.slider.slider-horizontal .slider-handle {
  margin-left: -10px;
}

.slider.slider-horizontal .slider-tick.triangle,
.slider.slider-horizontal .slider-handle.triangle {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  border-width: 0 10px 10px 10px;
  width: 0;
  height: 0;
  border-bottom-color: #036fa5;
  margin-top: 0;
}

.slider.slider-horizontal .slider-tick-container {
  white-space: nowrap;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.slider.slider-horizontal .slider-tick-label-container {
  white-space: nowrap;
  margin-top: 20px;
}

.slider.slider-horizontal .slider-tick-label-container .slider-tick-label {
  display: inline-block;
  text-align: center;
}

.slider.slider-horizontal.slider-rtl .slider-track {
  left: initial;
  right: 0;
}

.slider.slider-horizontal.slider-rtl .slider-tick,
.slider.slider-horizontal.slider-rtl .slider-handle {
  margin-left: initial;
  margin-right: -10px;
}

.slider.slider-horizontal.slider-rtl .slider-tick-container {
  left: initial;
  right: 0;
}

.slider.slider-vertical {
  height: 210px;
  width: 20px;
}

.slider.slider-vertical .slider-track {
  width: 10px;
  height: 100%;
  left: 25%;
  top: 0;
}

.slider.slider-vertical .slider-selection {
  width: 100%;
  left: 0;
  top: 0;
  bottom: 0;
}

.slider.slider-vertical .slider-track-low, .slider.slider-vertical .slider-track-high {
  width: 100%;
  left: 0;
  right: 0;
}

.slider.slider-vertical .slider-tick,
.slider.slider-vertical .slider-handle {
  margin-top: -10px;
}

.slider.slider-vertical .slider-tick.triangle,
.slider.slider-vertical .slider-handle.triangle {
  border-width: 10px 0 10px 10px;
  width: 1px;
  height: 1px;
  border-left-color: #036fa5;
  margin-left: 0;
}

.slider.slider-vertical .slider-tick-label-container {
  white-space: nowrap;
}

.slider.slider-vertical .slider-tick-label-container .slider-tick-label {
  padding-left: 4px;
}

.slider.slider-vertical.slider-rtl .slider-track {
  left: initial;
  right: 25%;
}

.slider.slider-vertical.slider-rtl .slider-selection {
  left: initial;
  right: 0;
}

.slider.slider-vertical.slider-rtl .slider-tick.triangle,
.slider.slider-vertical.slider-rtl .slider-handle.triangle {
  border-width: 10px 10px 10px 0;
}

.slider.slider-vertical.slider-rtl .slider-tick-label-container .slider-tick-label {
  padding-left: initial;
  padding-right: 4px;
}

.slider.slider-disabled .slider-handle {
  background-color: #cfcfcf;
  background-image: -moz-linear-gradient(top, #DFDFDF, #BEBEBE);
  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#DFDFDF), to(#BEBEBE));
  background-image: -webkit-linear-gradient(top, #DFDFDF, #BEBEBE);
  background-image: -o-linear-gradient(top, #DFDFDF, #BEBEBE);
  background-image: linear-gradient(to bottom, #DFDFDF, #BEBEBE);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#DFDFDF', endColorstr='#BEBEBE',GradientType=0);
}

.slider.slider-disabled .slider-track {
  background-color: #e7e7e7;
  background-image: -moz-linear-gradient(top, #E5E5E5, #E9E9E9);
  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#E5E5E5), to(#E9E9E9));
  background-image: -webkit-linear-gradient(top, #E5E5E5, #E9E9E9);
  background-image: -o-linear-gradient(top, #E5E5E5, #E9E9E9);
  background-image: linear-gradient(to bottom, #E5E5E5, #E9E9E9);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#E5E5E5', endColorstr='#E9E9E9',GradientType=0);
  cursor: not-allowed;
}

.slider input {
  display: none;
}

.slider .tooltip-inner {
  white-space: nowrap;
  max-width: none;
}

.slider .bs-tooltip-top .tooltip-inner,
.slider .bs-tooltip-bottom .tooltip-inner {
  position: relative;
  left: -50%;
}

.slider.bs-tooltip-left .tooltip-inner, .slider.bs-tooltip-right .tooltip-inner {
  position: relative;
  top: -100%;
}

.slider .tooltip {
  pointer-events: none;
}

.slider .tooltip.bs-tooltip-top .arrow, .slider .tooltip.bs-tooltip-bottom .arrow {
  left: -.4rem;
}

.slider .tooltip.bs-tooltip-top {
  margin-top: -44px;
}

.slider .tooltip.bs-tooltip-bottom {
  margin-top: 2px;
}

.slider .tooltip.bs-tooltip-left, .slider .tooltip.bs-tooltip-right {
  margin-top: -14px;
}

.slider .tooltip.bs-tooltip-left .arrow, .slider .tooltip.bs-tooltip-right .arrow {
  top: 8px;
}

.slider .hide {
  display: none;
}

.slider-track {
  background-color: #f7f7f7;
  background-image: -moz-linear-gradient(top, #F5F5F5, #F9F9F9);
  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#F5F5F5), to(#F9F9F9));
  background-image: -webkit-linear-gradient(top, #F5F5F5, #F9F9F9);
  background-image: -o-linear-gradient(top, #F5F5F5, #F9F9F9);
  background-image: linear-gradient(to bottom, #F5F5F5, #F9F9F9);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#F5F5F5', endColorstr='#F9F9F9',GradientType=0);
  -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  position: absolute;
  cursor: pointer;
}

.slider-selection {
  background-color: #f7f7f7;
  background-image: -moz-linear-gradient(top, #F9F9F9, #F5F5F5);
  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#F9F9F9), to(#F5F5F5));
  background-image: -webkit-linear-gradient(top, #F9F9F9, #F5F5F5);
  background-image: -o-linear-gradient(top, #F9F9F9, #F5F5F5);
  background-image: linear-gradient(to bottom, #F9F9F9, #F5F5F5);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#F9F9F9', endColorstr='#F5F5F5',GradientType=0);
  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  position: absolute;
}

.slider-selection.tick-slider-selection {
  background-color: #46c1fe;
  background-image: -moz-linear-gradient(top, #52c5ff, #3abcfd);
  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#52c5ff), to(#3abcfd));
  background-image: -webkit-linear-gradient(top, #52c5ff, #3abcfd);
  background-image: -o-linear-gradient(top, #52c5ff, #3abcfd);
  background-image: linear-gradient(to bottom, #52c5ff, #3abcfd);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#52c5ff', endColorstr='#3abcfd',GradientType=0);
}

.slider-track-low, .slider-track-high {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  position: absolute;
  background: transparent;
}

.slider-handle {
  background-color: #0478b2;
  background-image: -moz-linear-gradient(top, #0480BE, #036fa5);
  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#0480BE), to(#036fa5));
  background-image: -webkit-linear-gradient(top, #0480BE, #036fa5);
  background-image: -o-linear-gradient(top, #0480BE, #036fa5);
  background-image: linear-gradient(to bottom, #0480BE, #036fa5);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#0480BE', endColorstr='#036fa5',GradientType=0);
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05);
  position: absolute;
  top: 0;
  width: 20px;
  height: 20px;
  background-color: #0480BE;
  border: 0px solid transparent;
}

.slider-handle:hover {
  cursor: pointer;
}

.slider-handle.round {
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
}

.slider-handle.triangle {
  background: transparent none;
}

.slider-handle.custom {
  background: transparent none;
}

.slider-handle.custom::before {
  line-height: 20px;
  font-size: 20px;
  content: '\\2605';
  color: #726204;
}

.slider-tick {
  background-color: #f7f7f7;
  background-image: -moz-linear-gradient(top, #F5F5F5, #F9F9F9);
  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#F5F5F5), to(#F9F9F9));
  background-image: -webkit-linear-gradient(top, #F5F5F5, #F9F9F9);
  background-image: -o-linear-gradient(top, #F5F5F5, #F9F9F9);
  background-image: linear-gradient(to bottom, #F5F5F5, #F9F9F9);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#F5F5F5', endColorstr='#F9F9F9',GradientType=0);
  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  cursor: pointer;
  width: 20px;
  height: 20px;
  filter: none;
  opacity: 0.8;
  border: 0px solid transparent;
}

.slider-tick.round {
  border-radius: 50%;
}

.slider-tick.triangle {
  background: transparent none;
}

.slider-tick.custom {
  background: transparent none;
}

.slider-tick.custom::before {
  line-height: 20px;
  font-size: 20px;
  content: '\\2605';
  color: #726204;
}

.slider-tick.in-selection {
  background-color: #46c1fe;
  background-image: -moz-linear-gradient(top, #52c5ff, #3abcfd);
  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#52c5ff), to(#3abcfd));
  background-image: -webkit-linear-gradient(top, #52c5ff, #3abcfd);
  background-image: -o-linear-gradient(top, #52c5ff, #3abcfd);
  background-image: linear-gradient(to bottom, #52c5ff, #3abcfd);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#52c5ff', endColorstr='#3abcfd',GradientType=0);
  opacity: 1;
}

/*# sourceMappingURL=bootstrap-slider.css.map */`, "",{"version":3,"sources":["webpack://./node_modules/bootstrap-slider/dist/css/bootstrap-slider.css"],"names":[],"mappings":"AAAA;;2DAE2D;AAC3D;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8DAqC8D;AAC9D;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,MAAM;EACN,SAAS;AACX;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,8BAA8B;EAC9B,QAAQ;EACR,SAAS;EACT,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,MAAM;AACR;;AAEA;EACE,WAAW;EACX,OAAO;EACP,MAAM;EACN,SAAS;AACX;;AAEA;EACE,WAAW;EACX,OAAO;EACP,QAAQ;AACV;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,8BAA8B;EAC9B,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,6DAA6D;EAC7D,mFAAmF;EACnF,gEAAgE;EAChE,2DAA2D;EAC3D,8DAA8D;EAC9D,2BAA2B;EAC3B,iHAAiH;AACnH;;AAEA;EACE,yBAAyB;EACzB,6DAA6D;EAC7D,mFAAmF;EACnF,gEAAgE;EAChE,2DAA2D;EAC3D,8DAA8D;EAC9D,2BAA2B;EAC3B,iHAAiH;EACjH,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,6DAA6D;EAC7D,mFAAmF;EACnF,gEAAgE;EAChE,2DAA2D;EAC3D,8DAA8D;EAC9D,2BAA2B;EAC3B,iHAAiH;EACjH,sDAAsD;EACtD,mDAAmD;EACnD,8CAA8C;EAC9C,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,6DAA6D;EAC7D,mFAAmF;EACnF,gEAAgE;EAChE,2DAA2D;EAC3D,8DAA8D;EAC9D,2BAA2B;EAC3B,iHAAiH;EACjH,sDAAsD;EACtD,mDAAmD;EACnD,8CAA8C;EAC9C,8BAA8B;EAC9B,2BAA2B;EAC3B,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,6DAA6D;EAC7D,mFAAmF;EACnF,gEAAgE;EAChE,2DAA2D;EAC3D,8DAA8D;EAC9D,2BAA2B;EAC3B,iHAAiH;AACnH;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,6DAA6D;EAC7D,mFAAmF;EACnF,gEAAgE;EAChE,2DAA2D;EAC3D,8DAA8D;EAC9D,2BAA2B;EAC3B,iHAAiH;EACjH,yFAAyF;EACzF,sFAAsF;EACtF,iFAAiF;EACjF,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,6DAA6D;EAC7D,mFAAmF;EACnF,gEAAgE;EAChE,2DAA2D;EAC3D,8DAA8D;EAC9D,2BAA2B;EAC3B,iHAAiH;EACjH,sDAAsD;EACtD,mDAAmD;EACnD,8CAA8C;EAC9C,8BAA8B;EAC9B,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,6DAA6D;EAC7D,mFAAmF;EACnF,gEAAgE;EAChE,2DAA2D;EAC3D,8DAA8D;EAC9D,2BAA2B;EAC3B,iHAAiH;EACjH,UAAU;AACZ;;AAEA,+CAA+C","sourcesContent":["/*! =======================================================\n                      VERSION  11.0.2              \n========================================================= */\n/*! =========================================================\n * bootstrap-slider.js\n *\n * Maintainers:\n *\t\tKyle Kemp\n *\t\t\t- Twitter: @seiyria\n *\t\t\t- Github:  seiyria\n *\t\tRohit Kalkur\n *\t\t\t- Twitter: @Rovolutionary\n *\t\t\t- Github:  rovolution\n *\n * =========================================================\n *\n * bootstrap-slider is released under the MIT License\n * Copyright (c) 2019 Kyle Kemp, Rohit Kalkur, and contributors\n * \n * Permission is hereby granted, free of charge, to any person\n * obtaining a copy of this software and associated documentation\n * files (the \"Software\"), to deal in the Software without\n * restriction, including without limitation the rights to use,\n * copy, modify, merge, publish, distribute, sublicense, and/or sell\n * copies of the Software, and to permit persons to whom the\n * Software is furnished to do so, subject to the following\n * conditions:\n * \n * The above copyright notice and this permission notice shall be\n * included in all copies or substantial portions of the Software.\n * \n * THE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND,\n * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES\n * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND\n * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT\n * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,\n * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING\n * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR\n * OTHER DEALINGS IN THE SOFTWARE.\n *\n * ========================================================= */\n.slider {\n  display: inline-block;\n  vertical-align: middle;\n  position: relative;\n}\n\n.slider.slider-horizontal {\n  width: 210px;\n  height: 20px;\n}\n\n.slider.slider-horizontal .slider-track {\n  height: 10px;\n  width: 100%;\n  margin-top: -5px;\n  top: 50%;\n  left: 0;\n}\n\n.slider.slider-horizontal .slider-selection, .slider.slider-horizontal .slider-track-low, .slider.slider-horizontal .slider-track-high {\n  height: 100%;\n  top: 0;\n  bottom: 0;\n}\n\n.slider.slider-horizontal .slider-tick,\n.slider.slider-horizontal .slider-handle {\n  margin-left: -10px;\n}\n\n.slider.slider-horizontal .slider-tick.triangle,\n.slider.slider-horizontal .slider-handle.triangle {\n  position: relative;\n  top: 50%;\n  transform: translateY(-50%);\n  border-width: 0 10px 10px 10px;\n  width: 0;\n  height: 0;\n  border-bottom-color: #036fa5;\n  margin-top: 0;\n}\n\n.slider.slider-horizontal .slider-tick-container {\n  white-space: nowrap;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n}\n\n.slider.slider-horizontal .slider-tick-label-container {\n  white-space: nowrap;\n  margin-top: 20px;\n}\n\n.slider.slider-horizontal .slider-tick-label-container .slider-tick-label {\n  display: inline-block;\n  text-align: center;\n}\n\n.slider.slider-horizontal.slider-rtl .slider-track {\n  left: initial;\n  right: 0;\n}\n\n.slider.slider-horizontal.slider-rtl .slider-tick,\n.slider.slider-horizontal.slider-rtl .slider-handle {\n  margin-left: initial;\n  margin-right: -10px;\n}\n\n.slider.slider-horizontal.slider-rtl .slider-tick-container {\n  left: initial;\n  right: 0;\n}\n\n.slider.slider-vertical {\n  height: 210px;\n  width: 20px;\n}\n\n.slider.slider-vertical .slider-track {\n  width: 10px;\n  height: 100%;\n  left: 25%;\n  top: 0;\n}\n\n.slider.slider-vertical .slider-selection {\n  width: 100%;\n  left: 0;\n  top: 0;\n  bottom: 0;\n}\n\n.slider.slider-vertical .slider-track-low, .slider.slider-vertical .slider-track-high {\n  width: 100%;\n  left: 0;\n  right: 0;\n}\n\n.slider.slider-vertical .slider-tick,\n.slider.slider-vertical .slider-handle {\n  margin-top: -10px;\n}\n\n.slider.slider-vertical .slider-tick.triangle,\n.slider.slider-vertical .slider-handle.triangle {\n  border-width: 10px 0 10px 10px;\n  width: 1px;\n  height: 1px;\n  border-left-color: #036fa5;\n  margin-left: 0;\n}\n\n.slider.slider-vertical .slider-tick-label-container {\n  white-space: nowrap;\n}\n\n.slider.slider-vertical .slider-tick-label-container .slider-tick-label {\n  padding-left: 4px;\n}\n\n.slider.slider-vertical.slider-rtl .slider-track {\n  left: initial;\n  right: 25%;\n}\n\n.slider.slider-vertical.slider-rtl .slider-selection {\n  left: initial;\n  right: 0;\n}\n\n.slider.slider-vertical.slider-rtl .slider-tick.triangle,\n.slider.slider-vertical.slider-rtl .slider-handle.triangle {\n  border-width: 10px 10px 10px 0;\n}\n\n.slider.slider-vertical.slider-rtl .slider-tick-label-container .slider-tick-label {\n  padding-left: initial;\n  padding-right: 4px;\n}\n\n.slider.slider-disabled .slider-handle {\n  background-color: #cfcfcf;\n  background-image: -moz-linear-gradient(top, #DFDFDF, #BEBEBE);\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#DFDFDF), to(#BEBEBE));\n  background-image: -webkit-linear-gradient(top, #DFDFDF, #BEBEBE);\n  background-image: -o-linear-gradient(top, #DFDFDF, #BEBEBE);\n  background-image: linear-gradient(to bottom, #DFDFDF, #BEBEBE);\n  background-repeat: repeat-x;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#DFDFDF', endColorstr='#BEBEBE',GradientType=0);\n}\n\n.slider.slider-disabled .slider-track {\n  background-color: #e7e7e7;\n  background-image: -moz-linear-gradient(top, #E5E5E5, #E9E9E9);\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#E5E5E5), to(#E9E9E9));\n  background-image: -webkit-linear-gradient(top, #E5E5E5, #E9E9E9);\n  background-image: -o-linear-gradient(top, #E5E5E5, #E9E9E9);\n  background-image: linear-gradient(to bottom, #E5E5E5, #E9E9E9);\n  background-repeat: repeat-x;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#E5E5E5', endColorstr='#E9E9E9',GradientType=0);\n  cursor: not-allowed;\n}\n\n.slider input {\n  display: none;\n}\n\n.slider .tooltip-inner {\n  white-space: nowrap;\n  max-width: none;\n}\n\n.slider .bs-tooltip-top .tooltip-inner,\n.slider .bs-tooltip-bottom .tooltip-inner {\n  position: relative;\n  left: -50%;\n}\n\n.slider.bs-tooltip-left .tooltip-inner, .slider.bs-tooltip-right .tooltip-inner {\n  position: relative;\n  top: -100%;\n}\n\n.slider .tooltip {\n  pointer-events: none;\n}\n\n.slider .tooltip.bs-tooltip-top .arrow, .slider .tooltip.bs-tooltip-bottom .arrow {\n  left: -.4rem;\n}\n\n.slider .tooltip.bs-tooltip-top {\n  margin-top: -44px;\n}\n\n.slider .tooltip.bs-tooltip-bottom {\n  margin-top: 2px;\n}\n\n.slider .tooltip.bs-tooltip-left, .slider .tooltip.bs-tooltip-right {\n  margin-top: -14px;\n}\n\n.slider .tooltip.bs-tooltip-left .arrow, .slider .tooltip.bs-tooltip-right .arrow {\n  top: 8px;\n}\n\n.slider .hide {\n  display: none;\n}\n\n.slider-track {\n  background-color: #f7f7f7;\n  background-image: -moz-linear-gradient(top, #F5F5F5, #F9F9F9);\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#F5F5F5), to(#F9F9F9));\n  background-image: -webkit-linear-gradient(top, #F5F5F5, #F9F9F9);\n  background-image: -o-linear-gradient(top, #F5F5F5, #F9F9F9);\n  background-image: linear-gradient(to bottom, #F5F5F5, #F9F9F9);\n  background-repeat: repeat-x;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#F5F5F5', endColorstr='#F9F9F9',GradientType=0);\n  -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n  -moz-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n  position: absolute;\n  cursor: pointer;\n}\n\n.slider-selection {\n  background-color: #f7f7f7;\n  background-image: -moz-linear-gradient(top, #F9F9F9, #F5F5F5);\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#F9F9F9), to(#F5F5F5));\n  background-image: -webkit-linear-gradient(top, #F9F9F9, #F5F5F5);\n  background-image: -o-linear-gradient(top, #F9F9F9, #F5F5F5);\n  background-image: linear-gradient(to bottom, #F9F9F9, #F5F5F5);\n  background-repeat: repeat-x;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#F9F9F9', endColorstr='#F5F5F5',GradientType=0);\n  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);\n  -moz-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);\n  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n  position: absolute;\n}\n\n.slider-selection.tick-slider-selection {\n  background-color: #46c1fe;\n  background-image: -moz-linear-gradient(top, #52c5ff, #3abcfd);\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#52c5ff), to(#3abcfd));\n  background-image: -webkit-linear-gradient(top, #52c5ff, #3abcfd);\n  background-image: -o-linear-gradient(top, #52c5ff, #3abcfd);\n  background-image: linear-gradient(to bottom, #52c5ff, #3abcfd);\n  background-repeat: repeat-x;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#52c5ff', endColorstr='#3abcfd',GradientType=0);\n}\n\n.slider-track-low, .slider-track-high {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n  position: absolute;\n  background: transparent;\n}\n\n.slider-handle {\n  background-color: #0478b2;\n  background-image: -moz-linear-gradient(top, #0480BE, #036fa5);\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#0480BE), to(#036fa5));\n  background-image: -webkit-linear-gradient(top, #0480BE, #036fa5);\n  background-image: -o-linear-gradient(top, #0480BE, #036fa5);\n  background-image: linear-gradient(to bottom, #0480BE, #036fa5);\n  background-repeat: repeat-x;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#0480BE', endColorstr='#036fa5',GradientType=0);\n  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05);\n  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05);\n  position: absolute;\n  top: 0;\n  width: 20px;\n  height: 20px;\n  background-color: #0480BE;\n  border: 0px solid transparent;\n}\n\n.slider-handle:hover {\n  cursor: pointer;\n}\n\n.slider-handle.round {\n  -webkit-border-radius: 20px;\n  -moz-border-radius: 20px;\n  border-radius: 20px;\n}\n\n.slider-handle.triangle {\n  background: transparent none;\n}\n\n.slider-handle.custom {\n  background: transparent none;\n}\n\n.slider-handle.custom::before {\n  line-height: 20px;\n  font-size: 20px;\n  content: '\\2605';\n  color: #726204;\n}\n\n.slider-tick {\n  background-color: #f7f7f7;\n  background-image: -moz-linear-gradient(top, #F5F5F5, #F9F9F9);\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#F5F5F5), to(#F9F9F9));\n  background-image: -webkit-linear-gradient(top, #F5F5F5, #F9F9F9);\n  background-image: -o-linear-gradient(top, #F5F5F5, #F9F9F9);\n  background-image: linear-gradient(to bottom, #F5F5F5, #F9F9F9);\n  background-repeat: repeat-x;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#F5F5F5', endColorstr='#F9F9F9',GradientType=0);\n  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);\n  -moz-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);\n  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  position: absolute;\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n  filter: none;\n  opacity: 0.8;\n  border: 0px solid transparent;\n}\n\n.slider-tick.round {\n  border-radius: 50%;\n}\n\n.slider-tick.triangle {\n  background: transparent none;\n}\n\n.slider-tick.custom {\n  background: transparent none;\n}\n\n.slider-tick.custom::before {\n  line-height: 20px;\n  font-size: 20px;\n  content: '\\2605';\n  color: #726204;\n}\n\n.slider-tick.in-selection {\n  background-color: #46c1fe;\n  background-image: -moz-linear-gradient(top, #52c5ff, #3abcfd);\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#52c5ff), to(#3abcfd));\n  background-image: -webkit-linear-gradient(top, #52c5ff, #3abcfd);\n  background-image: -o-linear-gradient(top, #52c5ff, #3abcfd);\n  background-image: linear-gradient(to bottom, #52c5ff, #3abcfd);\n  background-repeat: repeat-x;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#52c5ff', endColorstr='#3abcfd',GradientType=0);\n  opacity: 1;\n}\n\n/*# sourceMappingURL=bootstrap-slider.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
